import { ReactNode, useEffect, useState } from "react"

export default function FadeIn(props: {
    timeout?: number;
    children: ReactNode;
}) {

    const [active, setActive] = useState(!props.timeout);

    useEffect(() => {
        const t = setTimeout(() => {
            setActive(true);
        }, props.timeout);

        return () => {
            clearTimeout(t);
        }
    }, []);

    if (!active) return null;

    return (
        <div className="fade-in">{props.children}</div>
    );
}